import { noop } from 'rxjs';
import { MemoryService } from '../base/memoryService';
import { NULL_SERVICE, Service } from '../base/service';

export interface FocusService extends Service {
  readonly isActive: boolean;
  readonly isPendingFocus?: boolean;
  /** Whether the state is based memory, rather than a live element. */
  readonly isDisconnected?: boolean;

  setActive(isActive: boolean): void;
  focus(): void;
  blur(): void;
}

export const NULL_FOCUS_SERVICE: FocusService = {
  ...NULL_SERVICE,
  isActive: false,
  setActive: noop,
  focus: noop,
  blur: noop,
};

export function createMemoryFocusService(): FocusService {
  return new MemoryFocusService(false);
}

export class MemoryFocusService extends MemoryService<boolean> implements FocusService {
  readonly isDisconnected = true;

  get isActive() {
    return this.state;
  }

  setActive(isActive: boolean) {
    this.setState(isActive);
  }

  focus() {
    this.setActive(true);
  }

  blur() {
    this.setActive(false);
  }
}
